import axios from 'axios';
import {saveAs} from "file-saver";
import iziToast from "izitoast";
import store from '../redux/store'
import * as _ from 'lodash';
import {EMPTY, from, Observable} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {navigate} from "@reach/router";


const HTTP_GET = "GET";
const HTTP_POST = "POST";
const HTTP_PUT = "PUT";
const HTTP_DELETE = "DELETE";

export const BASE_ROUTE = process.env.NODE_ENV.toString() === 'production' ? 'https://2vvklfoex2.execute-api.us-west-2.amazonaws.com/dev/' : "http://localhost:5000/";

export default {

  downloadVaultFile(vaultId, fileName) {
    const data = {
      file_name: fileName
    };
    this.makeHTTPCall(`vaults/${vaultId}/download_file`, HTTP_POST, data)
      .pipe(
        catchError((err, caught) => {
          iziToast.error({
            position: "topCenter",
            'title': 'Error',
            'message': 'Unable to download this file.'
          });
        })
      )
      .subscribe((response) => {
        this.downloadFile(response.data["url"], fileName)
      });
  },

  downloadFile(url, fileName) {
    fetch(url).then(res => res.blob()).then(blob => saveAs(blob, fileName));
  },

  createVault(data) {
    return this.makeHTTPCall("vaults", HTTP_POST, data);
  },

  updateDocumentCategory(userId, categoryType, categoryId, categorySubType, documents) {
    const data = {
      user_id: userId,
      category_type: categoryType,
      category_id: categoryId,
      category_sub_type: categorySubType,
      documents: documents,
    }
    return this.makeHTTPCall("document_category", HTTP_PUT, data);
  },

  createAccessRequest(vaultId, data) {
    return this.makeHTTPCall(`vaults/${vaultId}/access`, HTTP_POST, data);
  },

  cancelAccessRequest(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}/access`, HTTP_DELETE);
  },

  getUser() {
    return this.makeHTTPCall("users", HTTP_GET, );
  },

  getVaults() {
    return this.makeHTTPCall("vaults", HTTP_GET, );
  },

  getVault(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}`, HTTP_GET, );
  },

  getClient(clientId) {
    return this.makeHTTPCall(`clients/${clientId}`, HTTP_GET, );
  },

  updateVault(vaultId, data) {
    return this.makeHTTPCall(`vaults/${vaultId}`, HTTP_PUT, data );
  },

  deleteVault(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}`, HTTP_DELETE, );
  },

  getVaultAccessRequest(vaultId, accessRequestCode) {
    return this.makeHTTPCall(`vaults/${vaultId}/access/${accessRequestCode}`, HTTP_GET, null, false);
  },

  approveVaultAccessRequestNoAuth(vaultId, accessRequestCode) {
    return this.makeHTTPCall(`vaults/${vaultId}/access/${accessRequestCode}`, HTTP_POST, {status: "APPROVED"} , null, false);
  },

  approveVaultAccessRequestAuth(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}/access`, HTTP_PUT, {status: "APPROVED"} );
  },

  rejectVaultAccessRequestAuth(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}/access`, HTTP_PUT, {status: "REJECTED"} );
  },

  lockVault(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}/lock`, HTTP_POST, {} );
  },

  toggleVaultArchived(vaultId) {
    return this.makeHTTPCall(`vaults/${vaultId}/toggle_archived`, HTTP_POST, {} );
  },

  rejectVaultAccessRequestNoAuth(vaultId, accessRequestCode) {
    return this.makeHTTPCall(`vaults/${vaultId}/access/${accessRequestCode}`, HTTP_POST, {status: "REJECTED"} );
  },

  createClient(clientData) {
    return this.makeHTTPCall(`clients`, HTTP_POST, clientData );
  },

  createSubscription(planType, paymentToken, couponCode) {
    const data = {
      plan_type: planType,
      payment_token: paymentToken,
      coupon_code: couponCode
    };
    return this.makeHTTPCall(`subscriptions`, HTTP_POST, data );
  },

  cancelSubscription() {
    return this.makeHTTPCall(`subscriptions`, HTTP_DELETE);
  },

  resendVerificationEmail() {
    return this.makeHTTPCall(`resend_verification_email`, HTTP_POST, {});
  },

  checkCouponCode(couponCode) {
    return this.makeHTTPCall(`check_coupon_code`, HTTP_POST, {
      "coupon_code": couponCode
    });
  },

  async getRequest(route, action, data={}, headers={}, useToken=true) {
    route = BASE_ROUTE + route;
    headers = {
      ...headers,
      "Content-Type": "application/json",
    };

    if (useToken) {
      const state = store.getState();
      const token = await state["user"]["token"]
      headers = {
        ...headers,
        "Authorization": `bearer ${token}`
      };
    }

    switch(action) {
      case HTTP_GET:
        return axios.get(route, {headers: headers});
      case HTTP_POST:
        return axios.post(route, data, {headers: headers});
      case HTTP_PUT:
        return axios.put(route, data, {headers: headers});
      case HTTP_DELETE:
        return axios.delete(route, {headers: headers});
    }
  },

  makeHTTPCall(route, action, data={}, headers={}, useToken=true, errorMessage='', navigateOnError=true) {
    return new Observable((observer) => {
      from(this.getRequest(route, action, data, headers, useToken))
        .pipe(
          catchError((error, caught) => {
            const errorCode = _.get(error, 'response.status', null);
            switch(errorCode) {
              case null:
              case 500:
                console.log(error)
                navigate("/unknown-error")
                return EMPTY
              case 401:
              case 403:
                iziToast.error({
                  position: "topCenter",
                  'title': 'Error',
                  'message': 'You do not have permission to perform that action. Please contact the Vault Owner or support for more assistance.'
                });
                navigate("/vaults")
                break;
              case 404:
                iziToast.error({
                  position: "topCenter",
                  'title': 'Error',
                  'message': 'This Vault was not found (or no longer exists). Please contact support for more assistance.'
                });
                navigate("/vaults")
                break;
              case 400:
                if (error.response.data) {
                  iziToast.error({
                    position: "topCenter",
                    'title': 'Error',
                    'message': error.response.data
                  });
                }
            }
            return EMPTY
          }),
          finalize(() => observer.complete())
        )
        .subscribe(observer)
    })
  }
}
